/**
 * Return value to uppercase and replace spaces with underscore.
 *
 * @param value
 */
window.uppercaseAndReplaceSpaces = (value) => {
    // Get current value, convert to uppercase, and replace all spaces with '_'
    let formatted = value.toUpperCase();
    formatted = formatted.replace(/\s/g, '_');

    return formatted;
}
